import { render, staticRenderFns } from "./LastScanItem.vue?vue&type=template&id=c95d8894&scoped=true"
import script from "./LastScanItem.vue?vue&type=script&lang=ts"
export * from "./LastScanItem.vue?vue&type=script&lang=ts"
import style0 from "./LastScanItem.vue?vue&type=style&index=0&id=c95d8894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95d8894",
  null
  
)

export default component.exports